/* Keep submitted service details in this tab while validation is resolved. */
(() => {
  const lifetime = 30 * 60 * 1000;
  function init(root = document) {
    root.querySelectorAll('.client-services-page__form, .returns-form__form').forEach(form => {
      if (form.dataset.serviceBound) return;
      form.dataset.serviceBound = 'true';
      const key = `mlf-service-draft:${location.pathname}:${form.id}`;
      const fields = () => [...form.elements].filter(field =>
        /^(INPUT|SELECT|TEXTAREA)$/.test(field.tagName) &&
        /^contact\[/.test(field.name) &&
        !['hidden', 'password', 'file', 'submit', 'button'].includes(field.type)
      );
      const read = () => {
        try {
          const draft = JSON.parse(sessionStorage.getItem(key));
          if (draft && Date.now() - draft.savedAt < lifetime) return draft.values;
          sessionStorage.removeItem(key);
        } catch { /* Storage can be unavailable; native validation still preserves input. */ }
        return null;
      };
      const save = () => {
        const values = fields().map(field => ({ name: field.name, value: field.value, checked: field.checked }));
        try { sessionStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), values })); } catch { /* Optional enhancement. */ }
      };
      const success = form.querySelector('[data-service-success]');
      const error = form.querySelector('[data-service-error]');
      if (success) {
        try { sessionStorage.removeItem(key); } catch { /* Optional enhancement. */ }
      } else {
        const draft = read();
        if (Array.isArray(draft)) {
          fields().forEach(field => {
            const saved = draft.find(value => value.name === field.name &&
              (!['radio', 'checkbox'].includes(field.type) || value.value === field.value));
            if (!saved || (field.value && !error)) return;
            if (['radio', 'checkbox'].includes(field.type)) field.checked = Boolean(saved.checked);
            else if (field.tagName !== 'SELECT' || [...field.options].some(option => option.value === saved.value)) field.value = saved.value;
          });
        }
      }
      form.addEventListener('submit', save, { capture: true });
      form.addEventListener('invalid', save, { capture: true });
      form.addEventListener('reset', () => { try { sessionStorage.removeItem(key); } catch { /* Optional enhancement. */ } });
      if (error) {
        const email = form.querySelector('[name="contact[email]"]');
        if (email) {
          error.id ||= `${form.id}-errors`;
          email.setAttribute('aria-describedby', [...new Set(`${email.getAttribute('aria-describedby') || ''} ${error.id}`.trim().split(/\s+/))].join(' '));
        }
        error.focus();
      }
      if (success) success.focus();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', () => init());
})();
